import { GifsResult } from '@giphy/js-fetch-api'
import { IGif } from '@giphy/js-types'
import { useCallback, useRef } from 'react'
import { GET } from 'shared/util/fetch-methods'
import { getResults } from '.'
import appendQuery from 'append-query'

type Result = {}
type FavoritesResult = {
    data: {
        gifs: IGif[]
        pagination: {
            next_url: String
        }
    }
}
let requestMap: { [key: string]: Promise<Result> } = {}

function request<T>(url: string) {
    if (!requestMap[url]) {
        requestMap[url] = getResults(url, GET)
    }
    return requestMap[url] as Promise<T>
}

// just another flavor, here we have a data object that contains
// a gifs object and a pagination with a next_url (quite a bit different than our GifsResult)
export const favoritesPaginator = () => {
    const gifs: IGif[] = []
    // for deduping
    const gifIds: (string | number)[] = []
    let next: string | undefined
    let isDoneFetching = false
    let total_count = 0
    return async () => {
        if (isDoneFetching) {
            return { gifs, isDoneFetching, total_count }
        }
        let result: FavoritesResult
        if (next) {
            result = await request<FavoritesResult>(appendQuery(next, { is: 1, json: true }))
        } else {
            result = await request<FavoritesResult>(`/favorites?is=1&json=true`)
        }
        const {
            data: { gifs: newGifs, pagination },
        } = result
        const nextUrl = pagination.next_url
        // TODO this should be fixed on the backend
        next = nextUrl ? nextUrl.replace('http://', 'https://') : undefined
        newGifs.forEach((gif: IGif) => {
            const { id } = gif
            if (!gifIds.includes(id)) {
                // add gifs and gifIds
                gifs.push(gif)
                gifIds.push(id)
            }
        })
        isDoneFetching = !next
        return { gifs: [...gifs], isDoneFetching, total_count: 0 }
    }
}

export function useFavorites() {
    // fake our gif pagination which includes an offset and not
    // not this `next` nonsense
    const paginator = useRef(favoritesPaginator())
    const offsetRef = useRef(0)
    const fetchGifs = useCallback(async (_: number): Promise<GifsResult> => {
        const offset = offsetRef.current
        const { gifs, total_count } = await paginator.current()
        offsetRef.current = gifs.length
        const pagination = {
            count: gifs.length,
            total_count,
            offset,
        }
        return {
            data: gifs,
            meta: {
                msg: '',
                response_id: '',
                status: 200,
            },
            pagination,
        }
    }, [])
    return fetchGifs
}
